import ClockoutController from "../../core/clockout.controller";
import Inherit from "../../core/inherit";
import TreasuryDelegate from './treasury.delegate';

class TreasuryController extends Inherit(ClockoutController, TreasuryDelegate) {
    
    async initialize() {
        if (!this.user?.access?.length) {
            this.navigateLogin();
            return;
        }

        this.setState({ loading: true, user: this.data.user });

        // Load all data
        await this.loadAllData();
        
        this.setState({ loading: false });
    }

    async loadAllData() {
        // Individual API calls with separate state updates for progressive loading
        try {
            this.data.fetchTreasurySummary()
                .then(fundsData => {
                    this.setState({ fundsData, fundsLoaded: true });
                })
                .catch(error => {
                    console.error('[Treasury] Error fetching TreasurySummary:', error);
                });

            this.data.fetchTreasuryFunding()
                .then(recommendationData => {
                    this.setState({ recommendationData, recommendationLoaded: true });
                })
                .catch(error => {
                    console.error('[Treasury] Error fetching TreasuryFunding:', error);
                });

            this.data.fetchTreasuryKPIs()
                .then(kpiData => {
                    this.setState({ kpiData, kpiLoaded: true });
                })
                .catch(error => {
                    console.error('[Treasury] Error fetching TreasuryKPIs:', error);
                });

            this.data.fetchTreasuryReceivables()
                .then(agingData => {
                    this.setState({ agingData, agingLoaded: true });
                })
                .catch(error => {
                    console.error('[Treasury] Error fetching TreasuryReceivables:', error);
                });

            this.data.fetchTreasuryCashflow()
                .then(cashFlowData => {
                    this.setState({ cashFlowData, cashFlowLoaded: true });
                })
                .catch(error => {
                    console.error('[Treasury] Error fetching TreasuryCashflow:', error);
                });
        } catch (error) {
            console.error('[Treasury] Error loading treasury data:', error);
        }
    }

    async loadDataWithDateRange(startDate, endDate) {
        // Reload data with date filters
        const start = startDate.format('YYYY-MM-DD');
        const end = endDate.format('YYYY-MM-DD');

        try {
            this.data.fetchTreasurySummary(start, end)
                .then(fundsData => {
                    this.setState({ fundsData });
                })
                .catch(error => {
                    console.error('[Treasury] Error fetching TreasurySummary with date range:', error);
                });

            this.data.fetchTreasuryKPIs(start, end)
                .then(kpiData => {
                    this.setState({ kpiData });
                })
                .catch(error => {
                    console.error('[Treasury] Error fetching TreasuryKPIs with date range:', error);
                });

            this.data.fetchTreasuryCashflow(start, end)
                .then(cashFlowData => {
                    this.setState({ cashFlowData });
                })
                .catch(error => {
                    console.error('[Treasury] Error fetching TreasuryCashflow with date range:', error);
                });

            this.data.fetchTreasuryReceivables(start, end)
                .then(agingData => {
                    this.setState({ agingData });
                })
                .catch(error => {
                    console.error('[Treasury] Error fetching TreasuryReceivables with date range:', error);
                });
        } catch (error) {
            console.error('[Treasury] Error loading treasury data with date range:', error);
        }
    }
}

export default TreasuryController;
